import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from '../../app/connect';
import A from '@adsk/bim360-matrix-react-a';
import {childrenType} from '../../constants/proptype-validation';
import {changeLocationAction} from '../../app/actions';

class Link extends PureComponent {
  static displayName = 'Link';

  static propTypes = {
    to: PropTypes.string.isRequired,
    changeLocation: PropTypes.func.isRequired,
    children: childrenType.isRequired,
    className: PropTypes.string
  };

  render() {
    const {to, changeLocation, children, className} = this.props;
    /* eslint-disable no-script-url */
    return (
      <A onClick={() => changeLocation(to)} href="javascript:void(0);" className={className}>
        {children}
      </A>
    );
    /* eslint-enable no-script-url */
  }
}

const mapDispatchToProps = {
  changeLocation: changeLocationAction
};

export default connect(
  null,
  mapDispatchToProps
)(Link);
